import {
    Account, ConversionDto, DisclaimerDto, EmailsObjectDto,
    FlyerPageDto,
    FlyerStatus, FlyerTocDto,
    FlyerType,
    GuiSettingsDto,
    LanguageCulture,
    PromoDto,
    PromoItemsDto, UITextDto, URLSDto,
} from "../../dtos";
import * as Globals from "../../globals/index";

import {Action} from "../actions/flyerDetailsActions";
import {ActionType} from "../actionTypes";

export interface FlyerDetailsState {
    flyCode: string;
    flyCaption: string;
    flyDisplayCaption: string;
    flyDesc: string;
    flyValidFromUtc: any;
    flyValidToUtc: any;
    flyCreatedUtc: any;
    flyModifiedUtc: any;
    flyRecId: number;
    flyLacRecId: number;
    flyLacRec: LanguageCulture;

    flyFltRecId: number;
    flyFltRec: FlyerType;
    flyerPages: FlyerPageDto[];
    // flyConversionEmail: string;
    flyFstRec: FlyerStatus;
    flyFstRecId: number;
    flyAccRec?: Account;
    flyGusRec?: GuiSettingsDto;
    flyAcuRecId?: number;
    noPages?: number;
    flygusRecId?: number;
    flyerPromos?: PromoDto[];
    flyerPromoItems?: PromoItemsDto[];
    // flyConversionType: number;
    flyDisclaimer: string;
    qualificationLevel: number;
    // flyerSetting?: null | CheckoutSettingDto;
    type?: string;
    conversion?: null | ConversionDto;
    disclaimers?: null | DisclaimerDto;
    uiTexts?: null | UITextDto;
    urls?: null | URLSDto;
    flyPageLayoutPc: number;
    toc: FlyerTocDto[] | [];
    flyFlyerClassId?: number | null;
    contactDetails?: EmailsObjectDto
}

export class FlyerDetailsInitialState implements FlyerDetailsState {
    flyCode = "";
    flyCaption = "";
    flyDisplayCaption = "";
    flyDesc = "";
    flyValidFromUtc = undefined;
    flyValidToUtc = undefined;
    flyCreatedUtc = undefined;
    flyModifiedUtc = undefined;

    flyLacRecId = 0;
    flyLacRec = Globals.LANGUAGE_ENGLISH;
    flyRecId = 0;
    flyFltRecId = 0;
    flyFltRec = Globals.FLIPPING_FLYER_TYPE;
    flyerPages = [];
    // flyConversionEmail = "";
    flyFstRec = {
        fstRecId: 0,
        fstGuid: "",
        fstCode: 0,
        fstCaption: "",
    };
    flyFstRecId = 0;
    flyAcuRecId = 0;
    noPages = 2;
    // flyConversionType = 0;
    flyDisclaimer = '';
    qualificationLevel = 0;
    flyPageLayoutPc = 1;
    toc = []
}

// export class FlyerDetailsInitialState implements FlyerDetailsState {
//     code: string = "1";
//     caption: string = "2";
//     displayCaption: string = "3";
//     flyDescription: string = "4";
//     language: string = Globals.LANGUAGE_HEBREW;
//     startDate: Date | null = null;
//     endDate: Date | null = null;
//     FlyCreatedUtc: Date | null = null;
//     modifiedDate: Date | null = null;
//     flyerType: string = Globals.SMART_FLYER_TYPE;
// }

const initialState = new FlyerDetailsInitialState();

const reducer = (state: FlyerDetailsState = initialState, action: Action) => {
    switch (action.type) {
        case ActionType.RESET_FLYER_STATE:
            return {...initialState};

        case ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT:
            return {
                ...state,
                ...action.payload,
            };

        case ActionType.FLYER_DETAILS_SET_IMAGE_TO_TARGET_PAGE:
            const pageExistInCurrentFlyerStateForUpdate = state.flyerPages.some((page: FlyerPageDto) => {
                return page.flpRecId === action.payload.pageId
            });
            if(pageExistInCurrentFlyerStateForUpdate){
                return {
                    ...state,
                    flyerPages: state.flyerPages.map((page: FlyerPageDto) => {
                        if(page.flpRecId === action.payload.pageId){
                            page.flpImageUrl = action.payload.imageUrl;
                            page.flyImageThumbnailUrl = action.payload.imageThumbnailUrl
                        }
                        return page;
                    })
                };
            } else {
                return state
            }

        default:
            return state;
    }
};

export default reducer;
